// Sweep History has its own permission: it reads `sweep/history`, while Sweep
// Monitor reads the live wallet list and runs collect/incident actions.
export const XBIT_RELAY_SWEEP_HISTORY_PERMISSION_RESOURCE = 'xbit-relay:sweep-history';

export { DEFAULT_SWEEP_PROVIDER } from '../sweep-monitor/constants';
